import "./index.css";
import { Route, Routes } from "react-router-dom";
import React from "react";
import ReactGA from 'react-ga';
import { hotjar } from 'react-hotjar';

import Homepage from "./Home/App";
import MattressBuilderApp from "./MattressBuilder/App";
import StaticContactUs from "./StaticContactUs/StaticContactUs";
import StaticEvrbase from "./StaticBuildYourBed/StaticEvrbase";
import StaticFaq from "./StaticFaq/StaticFaq";
import StaticOurStory from "./StaticOurCommitment/OurCommitment";
import StaticOurStoryReact from "./StaticOurStory/OurStory";
// import StaticOurStory from "./StaticOurCommitment/OurCommimentVertical";
// import StaticOurStoryReact from "./StaticOurStory/StaticOurStoryReact";
import StaticReturns from "./Returns/StaticReturns";
import StaticReviews from "./StaticReviews/StaticReviews";
import StaticShipping2 from "./StaticShipping2/StaticShipping2";
import StaticShippingComponent from "./Shipping/StaticShipping";
import StaticWarranty from "./StaticShipping/StaticWarranty";
import WhyEvrbed from "./StaticWhyEvrBed/WhyEvrbed";

const None = () => (
  <main style={{ padding: "1rem" }}>
    <p>There is nothing here!</p>
  </main>
);

const App = () => {
  const TRACKING_ID = "UA-57977767-3";
  ReactGA.initialize(TRACKING_ID);

  const hjid = 3201432;
  const hjsv = 6;
  hotjar.initialize(hjid, hjsv);
  console.log("Hotjar initialized: " + hotjar.initialized());

  ReactGA.event({
    category: 'User',
    action: 'Opened Mattress Builder'
  });

  return (
    <Routes>
      <Route path="/" element={<Homepage />} />
      <Route path="mattress-builder" element={<MattressBuilderApp />} />
      <Route path="why-evrbed" element={<WhyEvrbed />} />
      <Route path="our-story" element={<StaticOurStoryReact />} />
      <Route path="reviews" element={<StaticReviews />} />
      <Route path="our-commitment" element={<StaticOurStory />} />
      <Route path="warranty" element={<StaticWarranty />} />
      <Route path="shipping-delivery2" element={<StaticShipping2 />} />
      <Route path="faqs" element={<StaticFaq />} />
      <Route path="shipping" element={<StaticShippingComponent />} />
      <Route path="returns" element={<StaticReturns />} />
      <Route path="evrbase" element={<StaticEvrbase />} />
      <Route path="contact-us" element={<StaticContactUs />} />
      <Route path="*" element={<None />} />
    </Routes>
  );
};

export default App;
